<template>
    <v-app-bar
        color="primary"
        dark
        flat
        app
    >
        <v-app-bar-nav-icon
            @click.stop="toggleLeftDrawer"
            class="toggle-side-menu-button"
        ></v-app-bar-nav-icon>

        <template
            v-for="(item, index) in leftTopMenu"
        >
            <top-menu-item
                :key="'leftTopMenu-' + index"
                :item="item"
            ></top-menu-item>
        </template>

        <v-spacer></v-spacer>

        <template
            v-for="(item, index) in rightTopMenu"
        >
            <top-menu-item
                :key="'rightTopMenu-' + index"
                :item="item"
            ></top-menu-item>
        </template>

        <!--        <v-btn-->
        <!--            icon-->
        <!--            dark-->
        <!--            @click="viewVideo"-->
        <!--        >-->
        <!--            <v-icon>-->
        <!--                $mdiPlayCircle-->
        <!--            </v-icon>-->
        <!--        </v-btn>-->

        <!--        <v-dialog-->
        <!--            v-model="videoDialog"-->
        <!--            @click:outside="closeVideoDialog"-->
        <!--            max-width="800"-->
        <!--        >-->
        <!--            <vue-plyr-->
        <!--                ref="video"-->
        <!--                v-if="tmpFile"-->
        <!--            >-->
        <!--                <video>-->
        <!--                    <source-->
        <!--                        :src="tmpFile.url"-->
        <!--                        :type="tmpFile.mime"-->
        <!--                        size="720"-->
        <!--                    >-->
        <!--                </video>-->
        <!--            </vue-plyr>-->
        <!--        </v-dialog>-->


        <!--        <template-->
        <!--            v-if="impersonating"-->
        <!--        >-->
        <!--            <v-tooltip-->
        <!--                bottom-->
        <!--            >-->
        <!--                <template v-slot:activator="{ on }">-->
        <!--                    <v-btn-->
        <!--                        icon-->
        <!--                        dark-->
        <!--                        v-on="on"-->
        <!--                        @click="impersonateReturn"-->
        <!--                    >-->
        <!--                        <v-icon>-->
        <!--                            $mdiAccountConvert-->
        <!--                        </v-icon>-->
        <!--                    </v-btn>-->
        <!--                </template>-->
        <!--                <span>-->
        <!--                    Return as-->
        <!--                    <span v-if="typeof impersonator !== 'undefined' && typeof impersonator.first_name !== 'undefined'">-->
        <!--                        {{ impersonator.first_name }}-->
        <!--                    </span>-->
        <!--                    <span v-if="typeof impersonator !== 'undefined' && typeof impersonator.last_name !== 'undefined'">-->
        <!--                        {{ impersonator.last_name }}-->
        <!--                    </span>-->
        <!--                </span>-->
        <!--            </v-tooltip>-->
        <!--        </template>-->

        <!--        <v-tooltip-->
        <!--            bottom-->
        <!--        >-->
        <!--            <template v-slot:activator="{ on }">-->
        <!--                <v-btn-->
        <!--                    icon-->
        <!--                    dark-->
        <!--                    v-on="on"-->
        <!--                    @click="toggleDarkMode"-->
        <!--                >-->
        <!--                    <v-icon>-->
        <!--                        {{ darkMode ? '$mdiWhiteBalanceSunny' : '$mdiWeatherNight' }}-->
        <!--                    </v-icon>-->
        <!--                </v-btn>-->
        <!--            </template>-->
        <!--            <span>-->
        <!--                {{ darkMode ? 'Light mode' : 'Dark mode' }}-->
        <!--            </span>-->
        <!--        </v-tooltip>-->


        <v-menu
            bottom
            left
            min-width="200"
            offset-y
        >
            <template v-slot:activator="{ on: menu }">
                <v-btn
                    icon
                    v-on="{ ...menu }"
                >
                    <v-icon
                        dark
                    >
                        $mdiShieldAccount
                    </v-icon>
                </v-btn>
            </template>
            <v-list class="pa-0">
                <v-list-item>
                    <v-list-item-content>
                        <v-list-item-title
                            class="text-center"
                        >
                            <template
                                v-if="typeof loggedInUser.first_name !== 'undefined' && loggedInUser.first_name !== null && typeof loggedInUser.last_name !== 'undefined' && loggedInUser.last_name !== null"
                            >
                                {{ loggedInUser.first_name + ' ' + loggedInUser.last_name }}
                            </template>
                            <template
                                v-else
                            >
                                {{ loggedInUser.UserName }}
                            </template>
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
                <v-divider></v-divider>

<!--                <v-list-item-->
<!--                    key="profile"-->
<!--                    @click="editProfile"-->
<!--                >-->
<!--                    <v-list-item-action-->
<!--                        class="mr-3"-->
<!--                    >-->
<!--                        <v-icon>$mdiAccount</v-icon>-->
<!--                    </v-list-item-action>-->
<!--                    <v-list-item-content>-->
<!--                        <v-list-item-title>My Profile</v-list-item-title>-->
<!--                    </v-list-item-content>-->
<!--                </v-list-item>-->
                <v-divider></v-divider>

                <v-list-item @click="doLogout">
<!--                    <v-list-item-action-->
<!--                        class="mr-3"-->
<!--                    >-->
<!--                        <v-icon>$mdiLockOpen</v-icon>-->
<!--                    </v-list-item-action>-->
                    <v-list-item-content>
                        <v-list-item-title
                            class="text-center"
                        >
                            Logout
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list>
        </v-menu>
    </v-app-bar>
</template>

<script>
    import TopMenuItem from './TopMenuItem';

    export default {
        name: 'Top-Menu',
        data() {
            return {
                timer: null,

                videoDialog: false,
                tmpFile: null
            }
        },
        components: {
            TopMenuItem,
        },
        computed: {
            rightDrawer() {
                return this.$store.getters['application/getRightDrawerStatus'];
            },
            drawer: {
                set(value) {
                    this.$store.commit('application/setDrawerStatus', value);
                },
                get() {
                    return this.$store.getters['application/getDrawerStatus'];
                }
            },
            loggedInUser() {
                return this.$store.getters['auth/getUser'];
            },
            leftTopMenu() {
                return this.$store.getters['application/getLeftTopBar'];
            },
            rightTopMenu() {
                return this.$store.getters['application/getRightTopBar'];
            },
            darkMode() {
                return this.$vuetify.theme.dark;
            },

            impersonating() {
                return typeof this.loggedInUser.impersonator !== 'undefined' && this.loggedInUser.impersonator !== null;
            },
            impersonator() {
                return this.loggedInUser.impersonator;
            },
        },
        methods: {
            toggleRightDrawer() {
                this.$store.commit('application/setRightDrawerStatus', !this.$store.getters['application/getRightDrawerStatus']);
            },
            toggleLeftDrawer() {
                this.$store.commit('application/setDrawerStatus', !this.$store.getters['application/setDrawerStatus']);
            },
            editProfile() {
                this.$router.push('/profile?tab=info');
            },
            doLogout() {
                this.$store.dispatch('auth/logout')
                    .then(response => {
                        this.$router.push('/login');
                    }).catch(error => {
                    console.error(error);
                });
            },
            toggleDarkMode() {
                const darkMode = !this.darkMode;
                localStorage.setItem('dark_mode', darkMode);
                this.$vuetify.theme.dark = darkMode;

                try {
                    let type = window.logs.USER_TOGGLED_TO_LIGHT_MODE;

                    if (darkMode) {
                        type = window.logs.USER_TOGGLED_TO_DARK_MODE;
                    }

                    this.$store.dispatch('logs/add', {type: type});
                } catch (err) {

                }
            },

            impersonateReturn() {
                window.location = '/impersonate-return';
            },


            viewVideo() {
                this.tmpFile = {
                    url: 'https://weanswerit.ams3.digitaloceanspaces.com/comms/files/5c12cebf28ff6eacb1a516d341cb6866',
                    mime: 'video/mp4',
                };

                this.videoDialog = true;
            },
            closeVideoDialog() {
                if (typeof this.$refs.video !== 'undefined') {
                    this.$refs.video;
                }

                this.videoDialog = false;
                this.tmpFile = null;
            }
        }
    }
</script>
